import { roleToString, stringToRole } from "./format-role.helper";

export const RoleFormatter = {
  roleToString,
  stringToRole,
};
